import { render, staticRenderFns } from "./SLive1.vue?vue&type=template&id=2a7722f8&scoped=true"
import script from "./SLive1.vue?vue&type=script&lang=js"
export * from "./SLive1.vue?vue&type=script&lang=js"
import style0 from "./SLive1.vue?vue&type=style&index=0&id=2a7722f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7722f8",
  null
  
)

export default component.exports